import { render, staticRenderFns } from "./ElectricityCardDetailOne.vue?vue&type=template&id=3c8997c1&"
import script from "./ElectricityCardDetailOne.vue?vue&type=script&lang=js&"
export * from "./ElectricityCardDetailOne.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports